module.exports = __webpack_public_path__ + "static/media/CARACOLVERCHI_MENU-normal.1db3e97c.png";